import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import OtherCaseStudy from "../../components/other-case"
import pinduk from "../../assets/img/pinduksite.webp"
import pinduk2 from "../../assets/img/ustunperformans.webp"
import detail from "../../assets/img/organik_buyume_01.webp"
import detail2 from "../../assets/img/kelime_pozisyon_takip.webp"
import meta from "../../assets/img/metaverse.webp"
import google from "../../assets/img/google_adwors.webp"
import duhan from "../../assets/img/teams/duhan-pinduk.webp"
import yagmur from "../../assets/img/teams/yagmur-pinduk.webp"
import busra from "../../assets/img/teams/busra-pinduk.webp"
import elif from "../../assets/img/teams/elifsu-pinduk.webp"
import baris from "../../assets/img/baris-pinduk.webp"
import basak from "../../assets/img/basak-pinduk.webp"
import customer from "../../assets/img/emrearslan.jpeg"

const ReferancesDetail = () => (
  <Layout>
    <SEO
      title="Pinduk Success Story | Flatart"
      description="SEO and advertising are at the heart of our success with Pinduk! Explore the results we achieved through SEO and advertising campaigns at Pinduk."
    />
    <div className="referances-detail py60 container" style={{ paddingBottom: 0, paddingTop: 0 }}>
      <div className="col-md-6 detail-left">
        <b>SUCCESS STORY</b>
        <h1>Pinduk</h1>
        <p>Pinduk, a brand contributing to domestic production with over 35 years of experience in hazelnut cultivation, gained a new digital identity in 2025 through a collaboration with Flatart Agency. With SEO, social media management, and digital ADS efforts, the brand has achieved a noticeable momentum in organic traffic growth. While strengthening its engagement with its target audience, it demonstrated sustainable growth in the digital market.</p>
        <h2>Challenges</h2>
        <ul>
          <li>&bull; Pinduk&apos;s sector share in the organic traffic pie was below 1%,</li>
          <li>&bull; 64% of traffic was brand-focused, limiting the acquisition of new customers,</li>
          <li>&bull; Low national brand awareness volume, with consumers having limited access to the product,</li>
          <li>&bull; Low rankings for sector-based target keywords — generally appearing on pages 2–10 in search engines.</li>
        </ul>

        <h2>Solution</h2>
        <p>As Flatart Agency, we developed a comprehensive and multifaceted strategy focused on Pinduk&apos;s brand awareness and digital presence:</p>
        <ul>
          <li>&bull; We built target audience personas aligned with the brand using digital data insights,</li>
          <li>&bull; New channels capable of connecting the brand with its potential audience were integrated into the strategy,</li>
          <li>&bull; With the new acquisition channel strategy in place, we restructured the category hierarchy to be user- and search-engine-friendly, and defined relevant product groups more accurately,</li>
          <li>&bull; We optimized each category and subcategory according to targeted commercial keywords, increased organic visibility, and prepared content aligned with user intent,</li>
          <li>&bull; We completed the conversion funnel by gaining rankings for purchase-intent searches, directing traffic toward sales.</li>
        </ul>
      </div>
      <div className="col-md-6 referances-boxs">
        <div className="boxs">
          <div className="box">
            <span>%62</span>
            <p>Organic Traffic<br />Increase</p>
          </div>
          <div className="box">
            <span>+%148</span>
            <p>Add-to-Cart<br />Conversion Increase</p>
          </div>
          <div className="box">
            <span>+%253</span>
            <p>Return on Ad Spend from paid channels</p>
          </div>
          <div className="box">
            <span>+%137</span>
            <p>New User<br />Count Increase</p>
          </div>
        </div>
        <div className="provided">
          <h3>Services Provided</h3>
          <div className="provided-box">
            <div className="box">
              <Link to="/digital-consulting/"></Link>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="42" viewBox="0 0 50 42" fill="none">
                <g clipPath="url(#clip0_825_78)">
                  <path d="M19.539 2.97072C19.1866 2.61838 18.6821 2.45822 18.2017 2.53029C17.7132 2.61037 17.2808 2.91467 17.0486 3.33908L8.54425 19.4108L3.92375 24.0313C2.53039 25.4246 1.98586 27.4826 2.48234 29.4125C0.792692 31.6467 0.992887 34.7938 2.96281 36.7797C4.01984 37.8367 5.44523 38.4213 6.94269 38.4213C8.44015 38.4213 9.33703 38.0049 10.33 37.2602C10.8425 37.3963 11.307 37.4604 11.7314 37.4604C12.6603 37.4604 13.5812 37.2121 14.43 36.7477L17.8093 40.127C18.49 40.8076 19.3948 41.176 20.3478 41.176C21.3007 41.176 22.2136 40.7996 22.8943 40.127C24.2956 38.7256 24.2956 36.4434 22.8943 35.042L19.6911 31.8389L20.3318 31.1983L36.4034 22.694C36.8439 22.4617 37.1482 22.0373 37.2122 21.5408C37.2923 21.0524 37.1161 20.5479 36.7718 20.2035L19.539 2.97072ZM33.0642 20.9242L19.6831 28.0112L11.7474 20.0754L18.8343 6.69436L33.0722 20.9322L33.0642 20.9242ZM17.1767 29.925L13.4931 33.6086C13.0206 34.0811 12.396 34.3373 11.7234 34.3373C11.0587 34.3373 10.4261 34.0731 9.95363 33.6086L6.11789 29.7729C5.14093 28.7959 5.14093 27.2184 6.11789 26.2414L9.80148 22.5578L17.1687 29.925H17.1767ZM7.19894 35.2742C6.45422 35.3543 5.70949 35.0981 5.17297 34.5696C4.63644 34.033 4.3882 33.2883 4.46828 32.5436L7.19094 35.2662L7.19894 35.2742ZM17.473 34.0571L20.6761 37.2602C20.7962 37.3803 20.8122 37.5164 20.8122 37.5885C20.8122 37.6606 20.7962 37.7967 20.6761 37.9168C20.4999 38.093 20.1956 38.093 20.0195 37.9168L16.8163 34.7137L17.473 34.0571Z" fill="black" />
                  <path d="M31.3186 10.0416C31.735 10.0416 32.1274 9.88146 32.4237 9.58517L35.1303 6.87853C35.7389 6.26993 35.7389 5.27697 35.1303 4.66036C34.834 4.36407 34.4417 4.20392 34.0252 4.20392C33.6088 4.20392 33.2165 4.36407 32.9202 4.66036L30.2135 7.367C29.6049 7.9756 29.6049 8.96857 30.2135 9.58517C30.5098 9.88146 30.9022 10.0416 31.3186 10.0416Z" fill="black" />
                  <path d="M25.9052 5.97363C26.7701 5.97363 27.4748 5.26895 27.4748 4.4041V1.69746C27.4748 0.832617 26.7701 0.12793 25.9052 0.12793C25.0404 0.12793 24.3357 0.832617 24.3357 1.69746V4.4041C24.3357 5.26895 25.0404 5.97363 25.9052 5.97363Z" fill="black" />
                  <path d="M38.0931 12.3239H35.3864C34.5216 12.3239 33.8169 13.0285 33.8169 13.8934C33.8169 14.7582 34.5216 15.4629 35.3864 15.4629H38.0931C38.9579 15.4629 39.6626 14.7582 39.6626 13.8934C39.6626 13.0285 38.9579 12.3239 38.0931 12.3239Z" fill="black" />
                </g>
                <defs>
                  <clipPath id="clip0_825_78">
                    <rect width="41" height="41" fill="white" transform="translate(0 0.159973)" />
                  </clipPath>
                </defs>
              </svg>
              Marketing Service
            </div>
            <div className="box">
              <Link to="/social-media/"></Link>
              <svg id="instagram-logo" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 61.312 61.312">
                <path id="Path_36346" data-name="Path 36346" d="M44.392,0H16.92A16.939,16.939,0,0,0,0,16.92V44.392a16.939,16.939,0,0,0,16.92,16.92H44.392a16.939,16.939,0,0,0,16.92-16.92V16.92A16.939,16.939,0,0,0,44.392,0ZM55.872,44.392a11.493,11.493,0,0,1-11.48,11.48H16.92A11.493,11.493,0,0,1,5.44,44.392V16.92A11.493,11.493,0,0,1,16.92,5.44H44.392a11.493,11.493,0,0,1,11.48,11.48V44.392Z" />
                <path id="Path_36347" data-name="Path 36347" d="M56.767,40.97a15.8,15.8,0,1,0,15.8,15.8A15.816,15.816,0,0,0,56.767,40.97Zm0,26.156A10.358,10.358,0,1,1,67.125,56.768,10.37,10.37,0,0,1,56.767,67.126Z" transform="translate(-26.111 -26.112)" />
                <path id="Path_36348" data-name="Path 36348" d="M122.91,28.251a3.987,3.987,0,1,0,2.821,1.168A4,4,0,0,0,122.91,28.251Z" transform="translate(-75.793 -18.005)" />
              </svg>
              Social Media
            </div>
            <div className="box">
              <Link to="/search-engine-optimization/"></Link>
              <svg style={{ marginLeft: -7 }} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 79 80">
                <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(-0.462 0.373)">
                  <rect id="bound" width="79" height="80" transform="translate(0.462 -0.373)" fill="none" />
                  <path id="Path-95" d="M9.6,55.773H59.071a3.3,3.3,0,0,1,0,6.6H6.3a3.3,3.3,0,0,1-3.3-3.3V6.3a3.3,3.3,0,0,1,6.6,0Z" transform="translate(6.895 7.094)" fill="#000000" />
                  <path id="Path-97" d="M12.7,33.493a3.3,3.3,0,0,1-4.812-4.512L20.261,15.788a3.3,3.3,0,0,1,4.547-.253l9.762,8.33L47.289,7.755a3.3,3.3,0,1,1,5.178,4.088l-14.842,18.8a3.3,3.3,0,0,1-4.73.465L22.92,22.6Z" transform="translate(16.088 15.138)" fill="#000000" opacity="0.3" />
                </g>
              </svg>
              SEO
            </div>
            <div className="box">
              <Link to="/digital-ads/"></Link>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 76 76">
                <g id="Icons-_-Shopping-_-Cart_1" data-name="Icons-/-Shopping-/-Cart#1" transform="translate(0.452 0.373)">
                  <rect id="bound" width="76" height="76" transform="translate(-0.452 -0.373)" fill="none" />
                  <path id="Combined-Shape" d="M52.453,31.233l-2.2,13.227-.008.046a3.161,3.161,0,0,1-3.675,2.544L10.63,40.517a3.161,3.161,0,0,1-2.474-2.241L2.389,18.088a3.161,3.161,0,0,1,3.039-4.029H48.813l1.938-8.306a3.729,3.729,0,0,1,3.632-2.882h6.527a3.729,3.729,0,1,1,0,7.459H57.342Z" transform="translate(4.899 6.203)" fillRule="evenodd" opacity="0.3" />
                  <path id="Combined-Shape-2" data-name="Combined-Shape" d="M9.741,27.482a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,9.741,27.482Zm28.447,0a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,38.188,27.482Z" transform="translate(10.804 38.894)" fillRule="evenodd" />
                </g>
              </svg>
              Digital Ads
            </div>
          </div>
        </div>
        <div className="project-details">
          <h3>Impressum</h3>
          <div className="project-details_list">
            <ul>
              <li>Marketing Manager:</li>
              <li>Digital Ads:</li>
              <li>SEO:</li>
              <li>Website Development:</li>
              <li>Content Writer:</li>
              <li>Designer:</li>
              <li>Social Media Manager:</li>
            </ul>
            <ul>
              <li className="flexpinduk"><img src={elif} alt="Elifsu Aktaş" />Elifsu Aktaş</li>
              <li className="flexpinduk"><img src={duhan} alt="Duhan Vatansever" />Duhan Vatansever</li>
              <li className="flexpinduk"><img src={yagmur} alt="Yağmur Çiftçi" />Yağmur Çiftçi</li>
              <li className="flexpinduk"><img src={busra} alt="Büşra Kanat" />Büşra Kanat</li>
              <li className="flexpinduk"><img src={baris} alt="Barış Yüksel" />Barış Yüksel</li>
              <li className="flexpinduk"><img src={basak} alt="Başak Gümüş" />Başak Gümüş</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="testimonial-customer" id="one" style={{ marginTop: '60px' }}>
        <p>"Working with Flatart on our digital marketing process was highly productive from start to finish. They truly understood our brand and goals, guiding us correctly on ad management, content language, and strategy. They shared every step transparently throughout the process, responded quickly, and were always reachable. Thanks to both their creative perspective and results-oriented approach, we saw tangible benefits in a short time. A team that knows its craft, inspires confidence, and is a pleasure to work with."</p>
        <div className="author">
          <div>
            <img src={customer} alt="Emre Arslan" />
          </div>
          <div className="author-name">
            Emre Arslan<br />
            <span>Digital Marketing Manager</span>
          </div>
        </div>
      </div>

      <div className="site-preview">
        <div className="mockup">
          <img src={pinduk} alt="Pinduk website preview" />
        </div>
      </div>

      <div className="customer-content test">
        <h2 className="pindukh2 padding">62% Organic Traffic Growth<br /> in a 3-Month SEO Period</h2>
        <div className="row-img">
          <img src={detail} className="detailpindukone" alt="Pinduk organic growth" />
        </div>
        <p>One of the main challenges of the Pinduk brand, whose technical and content SEO we undertook, was having a sector share below 1%. Within the solution recommendations we developed to address this issue, we incorporated SEO and content marketing. Through technical SEO efforts, we completed:</p>
        <ul className="pindukul">
          <li>&bull; keyword research,</li>
          <li>&bull; category-product-blog segmentation,</li>
          <li>&bull; sitemap and robots.txt updates,</li>
          <li>&bull; site speed and image optimizations,</li>
          <li>&bull; UX improvements,</li>
          <li>&bull; new categories &amp; footer optimization and user experience enhancement work.</li>
        </ul>
        <p>Through content marketing that supports SEO and aims to increase the brand&apos;s organic traffic, we prepared SEO-compliant content specific to main and subcategories. We also achieved growth in organic traffic and visibility through blog content that prioritizes SEO and UX experience.</p>

        <h2>Rising Rankings for<br /> Sector Keywords</h2>
        <p>For high-competition sector terms such as hazelnut, hazelnut flour, and roasted hazelnut — the brand&apos;s key sales categories — we performed technical improvements, content optimization, and page-level performance tracking. As a result of our optimizations, the brand achieved significant position gains for its primary keywords.</p>
        <p>Optimizing category and subcategory pages according to commercial search queries also provided a critical advantage for the brand in capturing users with purchase intent. Through all the SEO and content optimization work performed, Pinduk both expanded its organic visibility and strengthened its competitive position in the industry.</p>
        <div className="row-img">
          <img src={detail2} className="detailpindukone" alt="Pinduk keyword position tracking" />
        </div>

        <h2 className="pindukh2 start">253% ROAS with Digital Ads —<br />Outstanding Performance</h2>
        <h3 className="pindukh3">Advertising Channels</h3>
        <div className="metagoogle">
          <img src={meta} className="pindukmeta" alt="Meta ads" />
          <img src={google} className="pindukgoogle" alt="Google Ads" />
        </div>
        <p>In the digital advertising optimizations carried out (Meta + Google Ads), we modeled the target audience suited to Pinduk&apos;s product range. Campaigns were also redesigned based on segments with a propensity to purchase. As a result of the optimizations, within the first three months, the advertising campaigns reached a 253% ROAS (Return on Ad Spend). This allowed the brand to use its advertising budget far more efficiently and significantly increased the volume of traffic converting to sales.</p>
        <p>During the August–October 2025 period, the advertising campaigns run for Pinduk delivered remarkable results in both visibility and conversions. We ensured that ad spend reached the right audience segments, and the following results emerged:</p>
      </div>

      <div className="site-preview pinduk">
        <div className="mockup background">
          <img src={pinduk2} alt="Pinduk outstanding performance" />
        </div>
      </div>

      <div className="customer-content test">
        <h2>Conversion-Driven Growth<br /> Through Digital Ads</h2>
        <p>The quality traffic directed to the site through digital advertising campaigns also brought a noticeable improvement in overall user flow. Over the three-month period:</p>
        <ul className="pindukul">
          <li>&bull; 27,448 new visitors were acquired to the site,</li>
          <li>&bull; Consistent momentum was achieved across all conversion steps — first product interaction, add-to-cart, and purchase,</li>
          <li>&bull; A 69% increase was achieved in purchasing behavior,</li>
          <li>&bull; Ad-sourced sessions were restructured by the SEO team, reaching higher engagement through page structure and content optimizations.</li>
        </ul>
        <p>Through all our work, we ran a comprehensive digital marketing process for Pinduk that increased organic traffic, strengthened sales-focused conversions, and raised brand awareness. Our comprehensive and successful efforts also formed the foundation of Pinduk&apos;s sustainable digital growth infrastructure.</p>
        <p>We aim for the same success for all our brands and continue to produce lasting results with suitable digital marketing strategies.</p>
      </div>
    </div>

    <OtherCaseStudy />
    <Checkup />
  </Layout>
)

export default ReferancesDetail
